import React from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'

import { User } from '../types'

import style from './index.scss'
import Nav from '.'

const Account: React.FC<{
  baseUrl: string
  from?: string
  redirect?: string
  user?: User
  onClose: () => void
}> = ({ from = '', redirect, user, onClose }) => {
  const path =
    redirect || `${location.pathname}${location.search}${location.hash}`

  const basename = '/account'
  // eslint-disable-next-line compat/compat
  const searchParams = new URLSearchParams({ from, path })
  const loginUrl = `${basename}/login?${searchParams.toString()}`
  const signupUrl = `${basename}/register?${searchParams.toString()}`

  const items = user
    ? [
        () => (
          <div className={classNames(style.item, style['item-big'])}>
            {user.firstName ? `Hi, ${user.firstName}!` : 'Hi!'}
          </div>
        ),
        { label: 'Account', url: `${basename}/account-info` },
        { label: 'Orders', url: `${basename}/account-info/orders` },
        {
          label: 'Preferences',
          url: `${basename}/account-info/manage-subscriptions`,
        },
        () => <hr />,
        { label: 'Sign out', url: `${basename}/logout` },
      ]
    : [
        {
          label: 'Login',
          url: loginUrl.toString(),
          className: classNames(style['item-big']),
        },
        {
          label: 'Sign up',
          url: signupUrl.toString(),
          className: classNames(style['item-big']),
        },
        {
          label: 'About Westfield Plus',
          url: '/westfield-plus',
          target: '_blank',
        },
        () => (
          <>
            <div className={classNames(style.item, style.title)}>
              Members get more
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>Free delivery options</span>
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>10% back on Click &amp; Collect</span>
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>Easy returns</span>
            </div>
          </>
        ),
      ]

  return (
    <Nav
      className={classNames(style['nav-reverse'])}
      items={items}
      onClose={onClose}
    />
  )
}

export default Account
